/**
 * What the guide overlay has on screen right now, for the other pop-ups that share the screen with it (ui/toast.ts).
 * A tiny module with no imports, so the toast can read it without pulling in the overlay's DOM code.
 */
export interface GuideSurface {
  /** A bubble or card that holds the player's attention is up (anything but a tip): plain toasts wait. */
  readonly blocking: boolean;
  /** The y (overlay px) a toast must start below because a bubble is docked in the toasts' top slot; null if none. */
  readonly topClear: number | null;
}

const NONE: GuideSurface = { blocking: false, topClear: null };
let now: GuideSurface = NONE;

export function guideSurface(): GuideSurface { return now; }
/** guideOverlay.ts reports each change; null clears. */
export function setGuideSurface(s: GuideSurface | null): void { now = s ?? NONE; }
